export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_APP_OAUTH_CLIENT_ID as string,
    authority: import.meta.env.VITE_APP_OAUTH_AUTHORITY as string,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    temporaryCacheLocation: "localStorage",
    storeAuthStateInCookie: false,
    secureCookies: false,
    claimsBasedCachingEnabled: true,
  },
};
